import AppLayout from '@/components/layout/AppLayout';
import { Toaster } from '@/components/ui/toaster';
import { AuthGuard, AuthProvider } from '@/contexts/AuthContext';
import NotFound from '@/pages/not-found';
import AllProviders from '@/providers/AllProviders';
import { protectedRoutes, publicRoutes } from '@/routes/route-constants';
import { SnackbarProvider } from 'notistack';
import type { ComponentType } from 'react';
import { Route, Switch } from 'wouter';

// Wrapper component for login route with providers
function PublicRouteWrapper({ Component }: { Component: ComponentType<any> }) {
  return (
    <AuthProvider>
      <SnackbarProvider>
        <Toaster />
        <Component />
      </SnackbarProvider>
    </AuthProvider>
  );
}

export function AppRouter() {
  return (
    <Switch>
      {publicRoutes.map((route) => (
        <Route
          key={route.path}
          path={route.path}
          component={() => <PublicRouteWrapper Component={route.component} />}
        />
      ))}
      {/* Protected routes with AllProviders + AppLayout */}
      <Route>
        <AllProviders>
          <AppLayout>
            <AuthGuard>
              <Switch>
                {protectedRoutes.map((route) => (
                  <Route key={route.path} path={route.path} component={route.component} />
                ))}
                <Route component={NotFound} />
              </Switch>
            </AuthGuard>
          </AppLayout>
        </AllProviders>
      </Route>
    </Switch>
  );
}

export default AppRouter;
